/*
 * Hero background from YouTube, without looking like YouTube.
 *
 * The page loads with the poster image only. YouTube's player — about a
 * megabyte of script — is fetched once the page has finished loading and the
 * browser is idle, so it costs nothing in the page-speed measurements. The
 * video starts muted, stays invisible until it is actually playing, then fades
 * in over the poster. It never reaches its end: just before the last frame it
 * jumps back to the start, so YouTube's end screen and the flash between loops
 * never show. If autoplay is refused (Low Power Mode on an iPhone, a data
 * saver), the poster simply stays.
 */
(function () {
  var root = document.querySelector('[data-hero-yt]');
  if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var videoId = root.getAttribute('data-id');
  var mount = root.querySelector('[data-hero-yt-mount]');
  if (!videoId || !mount) return;

  var PLAYING = 1;
  var ENDED = 0;
  var player = null;
  var loopTimer = null;

  function reveal() {
    root.classList.add('is-playing');
  }

  // Jump back a moment before the end so the end screen never appears.
  function watchForEnd() {
    clearInterval(loopTimer);
    loopTimer = setInterval(function () {
      if (!player || typeof player.getDuration !== 'function') return;
      var duration = player.getDuration();
      var time = player.getCurrentTime();
      if (duration && time > duration - 0.4) player.seekTo(0, true);
    }, 200);
  }

  function create() {
    player = new window.YT.Player(mount, {
      host: 'https://www.youtube-nocookie.com',
      videoId: videoId,
      playerVars: {
        autoplay: 1,
        mute: 1,
        controls: 0,
        disablekb: 1,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      },
      events: {
        onReady: function (event) {
          event.target.mute();
          event.target.playVideo();
        },
        onStateChange: function (event) {
          if (event.data === PLAYING) {
            reveal();
            watchForEnd();
          } else if (event.data === ENDED) {
            event.target.seekTo(0, true);
            event.target.playVideo();
          }
        }
      }
    });
  }

  function loadApi() {
    if (window.YT && window.YT.Player) {
      create();
      return;
    }
    var previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof previous === 'function') previous();
      create();
    };
    var script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;
    document.head.appendChild(script);
  }

  function whenIdle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadApi, { timeout: 2500 });
    } else {
      setTimeout(loadApi, 1200);
    }
  }

  if (document.readyState === 'complete') {
    whenIdle();
  } else {
    window.addEventListener('load', whenIdle, { once: true });
  }
})();
